import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const slideDefinition: ComponentDefinition = {
  id: 'slide',
  name: 'Slide',
  category: 'Custom',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/frame.svg',
  children: true,
  variables: {
    stars: {
      type: 'Text',
      displayName: 'Stars',
      defaultValue: 'none',
      validations: {
        in: [
          { value: 'none', displayName: 'None' },
          { value: '5', displayName: '5' },
          { value: '4', displayName: '4' },
          { value: '3', displayName: '3' },
          { value: '2', displayName: '2' },
          { value: '1', displayName: '1' },
        ],
        bindingSourceType: ['manual', 'experience', 'entry'],
      },
    },
  },
} as const;
